import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<h3 id=\"thanks-message\">{{t \"messages.feedback_thanks\"}}</h3>",{ moduleName: "adcdriver/templates/thanks.hbs" })